import React, { useEffect, useState } from "react";
import "../Style.scss";

// backdrop component
import BackDrop from "../../../components/BackDrop.js";

/*---- Components imports ----------- */
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useAxios } from "../../../hooks/useAxios";
import FieldWorkerFilter from "../../../components/Filter/FieldWorkerFilter";
import format from "date-fns/format";
import { Button, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ExcelDownload from "../../../components/ExcelFormat/ExcelFileDownload";
import OptemIdReportFilter from "../../../components/Filter/OptemIdReportFilter";
import moment from "moment";

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
// import dates from '../../index.js'

import { dates } from "../../../index";

import {
  Table,
  makeStyles,
  FormControl,
  TableBody,
  TableCell,
  InputLabel,
  Input,
  Select,
  MenuItem,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
} from "@mui/material";
import CSVFileDownload from "../../../components/ExcelFormat/CSVFileDownload.js";

const head = [
  {
    field: "lineNo",
    headerName: "S.No",
    flex: 0,
    editable: false,
    renderCell: (params: GridRenderCellParams<DatasetEntryEntity>) =>
      params.api.getRowIndexRelativeToVisibleRows(params.row.id) + 1,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "ALL",
    headerName: "ALL",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "village_name",
    headerName: "Village Name",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "camp_place",
    headerName: "Camp Place Name",
    isChecked: false,
    width: 160,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "camp_no",
    headerName: " Camp No. ",
    isChecked: false,
    width: 160,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "name",
    headerName: "Patient Name",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "id",
    headerName: "Phone Number",
    isChecked: false,
    width: 190,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "gender",
    headerName: "Gender",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "complaint",
    headerName: "Complaint",
    isChecked: false,
    width: 100,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "defect_vision_left",
    headerName: "Defective Vision (Left Eye)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "defect_vision_right",
    headerName: "Defective Vision (Right Eye)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "already_wear_glass_yes",
    headerName: "Already Wearing Glass (yes) ",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "already_wear_glass_no",
    headerName: "Already Wearing Glass (No)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "diagnosis_left",
    headerName: "Diagnosis (Left Eye)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "diagnosis_right",
    headerName: "Diagnosis (Right Eye)",
    isChecked: false,
    width: 230,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_left_sph",
    headerName: "Near Vision Left Eye (Sph)",
    isChecked: false,
    width: 230,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_left_bcva",
    headerName: "Near Vision Left Eye (BCVA)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_left_cyl",
    headerName: "Near Vision Left Eye (Cyl)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_left_axis",
    headerName: "Near Vision Left Eye (Axis)",
    isChecked: false,
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_right_sph",
    headerName: "Near Vision Right Eye (Sph)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_right_bcva",
    headerName: "Near Vision Right Eye (BCVA)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_right_cyl",
    headerName: "Near Vision Right Eye (Cyl)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "near_vis_right_axis",
    headerName: "Near Vision Right Eye (Axis)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_left_sph",
    headerName: "Distance Vision Left Eye (Sph)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_left_bcva",
    headerName: "Distance Vision Left Eye (BCVA)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_left_cyl",
    headerName: "Distance Vision Left Eye (Cyl)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_left_axis",
    headerName: "Distance Vision Left Eye (Axis)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_right_sph",
    headerName: "Distance Vision Right Eye (Sph)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_right_bcva",
    headerName: "Distance Vision Right Eye (BCVA)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_right_cyl",
    headerName: "Distance Vision Right Eye (Cyl)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "dis_vis_right_axis",
    headerName: "Distance Vision Right Eye (Axis)",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "frame_size",
    headerName: "Frame Size",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "surgery_fit",
    headerName: "Surgery Fit",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "others",
    headerName: "Others",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "advice_to",
    headerName: "Advised To ",
    isChecked: false,
    width: 300,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "surgery_status",
    headerName: "Surgery Status",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "glass_prescription_status",
    headerName: "Glass Prescription Status",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "base_hospital_status",
    headerName: "Base Hospital Status ",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "vision_center_status",
    headerName: "Vision Center Status",
    isChecked: false,
    width: 130,
    headerClassName: "super-app-theme--header",
  },
];

const renderInputs = (props, placeholder, classname) => (
  <Input
    sx={{
      width: "100%",
      input: {
        "&::placeholder": {
          // <----- Add this.
          opacity: 1,
          // marginBottom: '-5px',
          paddingLeft: "10px",
          fontSize: "13px",
          color: "#000000",
        },
        width: "100%",
      },
      backgroundColor: "#ffffff",
      // borderRadius: '5px',
      // maxHeight: '50px'
    }}
    type="text"
    className={classname}
    inputRef={props.inputRef}
    // inputProps={props.inputProps}
    inputProps={{
      ...props.inputProps,
      placeholder: placeholder,
    }}
    value={props.value}
    onClick={props.onClick}
    onChange={props.onChange}
    endAdornment={props.InputProps?.endAdornment}
  />
);

const CbbfOptemReport = () => {
  const dateFormat = process.env.REACT_APP_DATE_FORMAT;

  function CustomToolBar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarContainer />

        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  }

  const { axios } = useAxios();

  // loader state
  const [backDropOpen, setBackDropOpen] = React.useState(false);

  const [rows, setRows] = React.useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [filterValue, setFilterValue] = React.useState({
    campStart: "",
    campEnd: "",
    hospitalName: "",
    fieldworkerName: "",
    camp_num: "",
    camp_place: "",
  });
  const [length, setlength] = React.useState(0);

  const [searchValue, setSearchValue] = React.useState({
    eventStart: "",
    eventEnd: "",
  });

  const [downloadTab, setDownloadTab] = useState(false);
  const [value, setValue] = useState([]);
  const [headerValue, setHeaderValue] = useState(head);
  const [dateSearch, setDateSearch] = useState("");

  const [tableInfo, setTableInfo] = useState({
    info: "Please apply filters to see the results",
  });

  const columns = [
    {
      field: "lineNo",
      headerName: "S.No",
      flex: 0,
      editable: false,
      renderCell: (params: GridRenderCellParams<DatasetEntryEntity>) =>
        params.api.getRowIndexRelativeToVisibleRows(params.row.id) + 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "village_name",
      headerName: "Village Name",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "camp_place",
      headerName: "Camp Place Name",
      width: 160,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "camp_no",
      headerName: " Camp No. ",
      width: 160,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "name",
      headerName: "Patient Name",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "id",
      headerName: "Phone Number",
      width: 190,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "complaint",
      headerName: "Complaint",
      width: 100,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "defect_vision_left",
      headerName: "Defective Vision (Left Eye)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "defect_vision_right",
      headerName: "Defective Vision (Right Eye)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "already_wear_glass_yes",
      headerName: "Already Wearing Glass (yes) ",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "already_wear_glass_no",
      headerName: "Already Wearing Glass (No)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "diagnosis_left",
      headerName: "Diagnosis (Left Eye)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "diagnosis_right",
      headerName: "Diagnosis (Right Eye)",
      width: 230,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_left_sph",
      headerName: "Near Vision Left Eye (Sph)",
      width: 230,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_left_bcva",
      headerName: "Near Vision Left Eye (BCVA)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_left_cyl",
      headerName: "Near Vision Left Eye (Cyl)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_left_axis",
      headerName: "Near Vision Left Eye (Axis)",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_right_sph",
      headerName: "Near Vision Right Eye (Sph)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_right_bcva",
      headerName: "Near Vision Right Eye (BCVA)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_right_cyl",
      headerName: "Near Vision Right Eye (Cyl)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "near_vis_right_axis",
      headerName: "Near Vision Right Eye (Axis)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_left_sph",
      headerName: "Distance Vision Left Eye (Sph)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_left_bcva",
      headerName: "Distance Vision Left Eye (BCVA)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_left_cyl",
      headerName: "Distance Vision Left Eye (Cyl)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_left_axis",
      headerName: "Distance Vision Left Eye (Axis)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_right_sph",
      headerName: "Distance Vision Right Eye (Sph)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_right_bcva",
      headerName: "Distance Vision Right Eye (BCVA)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_right_cyl",
      headerName: "Distance Vision Right Eye (Cyl)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dis_vis_right_axis",
      headerName: "Distance Vision Right Eye (Axis)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "frame_size",
      headerName: "Frame Size",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "surgery_fit",
      headerName: "Surgery Fit",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "others",
      headerName: "Others",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "advice_to",
      headerName: "Advised To ",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "surgery_status",
      headerName: "Surgery Status",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "glass_prescription_status",
      headerName: "Glass Prescription Status",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "base_hospital_status",
      headerName: "Base Hospital Status ",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "vision_center_status",
      headerName: "Vision Center Status",
      width: 130,
      headerClassName: "super-app-theme--header",
    },
  ];
  /*-------------   Rows -----------------------*/

  useEffect(() => {
    fetchData();
  }, [filterValue, paginationModel]);

  async function fetchData() {
    try {
      const isFilter = Object.values(filterValue)?.some(
        (value) => value.trim() !== ""
      );

      /* if filter applied then hit api else nothing to do */
      if (isFilter) {
        setTableInfo((prevState) => ({
          ...prevState,
          info: "Hang tight! We’re filtering the records based on your choices",
        }));

        const res = await axios.post(
          `CbbfOptometristsReport?fromDate=${filterValue.campStart}&toDate=${
            filterValue.campEnd
          }&hospital_name=${filterValue.hospitalName}&camp_number=${filterValue.camp_num}&camp_place=${
            filterValue.camp_place
          }&limit=${paginationModel.pageSize}&page=${paginationModel?.page + 1}` + (filterValue.field_worker_id ? `&field_worker_id=${
            filterValue.field_worker_id
          }` : '')
        );
        var l = res.data.result?.length || 0;

        if (l == 0) {
          setRows([]);
          setlength(l);
          setTableInfo((prevState) => ({
            ...prevState,
            info: "No records to display",
          }));
        } else {
          setlength(l);
          let newArrayOfObj = res.data.result.list.map(
            ({ phone_number: id, ...rest }) => ({ id, ...rest })
          );
          setRows(newArrayOfObj);
        }
      } else {
        setRows([]);
        setlength(0);
        setTableInfo((prevState) => ({
          ...prevState,
          info: "Please apply filters to see the results",
        }));
      }
    } catch (error) {}
  }

  function alterScreenName(name) {
    var menu_name = name.replaceAll("_", " ");
    var name = menu_name?.replace(/^.{1}/g, menu_name[0].toUpperCase());
    return name;
  }

  const handleChange = (e, val, position, headerName) => {
    const index = value?.findIndex((x) => x.value == val);

    // const ind = headerValue

    // setHeaderValue((x) => {
    //   {
    //     ...x,
    //     isChecked : false
    //   }

    // })

    if (e.target.checked) {
      if (index < 0) {
        if (headerName == "ALL") {
          let valueReference = [];
          head.forEach((data, index) => {
            data.isChecked = true;
            var values = {
              position: index,
              value: data?.field,
              header: data?.headerName,
            };
            valueReference.push(values);
            let sliceData = valueReference.slice(2);
            setValue(sliceData);
            // setValue(() => {
            //   var values = {
            //     position: index,
            //     value: data?.field,
            //     header: data?.headerName,
            //   };
            //   var data = { ...value, values };
            //   let returnData = Object.values(data);
            //   return returnData;
            // });
          });
        } else {
          head[position].isChecked = true;
          setValue(() => {
            var values = { position: position, value: val, header: headerName };
            var data = { ...value, values };
            return Object.values(data);
          });
        }
      } else {
        // value.splice(index, 1);
        if (headerName == "ALL") {
          head.forEach((data, index) => {
            data.isChecked = false;
          });
          setValue([]);
        } else {
          head[position].isChecked = false;
          value.splice(index, 1);
          setHeaderValue(head);
        }
      }
    } else {
      // value.splice(index, 1);
      if (headerName == "ALL") {
        head.forEach((data, index) => {
          data.isChecked = false;
        });
        setValue([]);
      } else {
        let headReference = [...head];
        headReference[position].isChecked = false;
        value.splice(index, 1);
        setHeaderValue(headReference);
      }
    }
  };

  function handleDates(val) {
    const today = new Date(); // Get the current date
    setDateSearch(val);

    // Format the dates as "DD-MM-YYYY"
    var dateFormat = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    if (val == "last_week") {
      //==============last week ======================

      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7); // Subtract 7 days to get the date for last week

      // Find the start date (Monday) of last week
      const startOfWeek = new Date(lastWeek);
      startOfWeek.setDate(lastWeek.getDate() - ((lastWeek.getDay() + 6) % 7));

      // Find the end date (Sunday) of last week
      const endOfWeek = new Date(lastWeek);
      endOfWeek.setDate(lastWeek.getDate() - ((lastWeek.getDay() + 6) % 7) + 6);

      // Format the dates
      var formattedStartOfWeek = startOfWeek.toISOString().split("T")[0];
      var formattedEndOfWeek = endOfWeek.toISOString().split("T")[0];

      setSearchValue((prevSearchDates) => ({
        ...prevSearchDates,
        eventStart: formattedStartOfWeek,
        eventEnd: formattedEndOfWeek,
      }));
    } else if (val == "last_month") {
      //================last month ===============================
      const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

      // Set the day to 1 to get the first day of the previous month
      lastMonth.setDate(2);

      setSearchValue((prevSearchDates) => ({
        ...prevSearchDates,
        eventStart: lastMonth.toISOString().split("T")[0],
        eventEnd: moment().date(0).toISOString().split("T")[0],
      }));
    } else if (val == "last_3_month") {
      //================last month ===============================

      const threeMonthsAgo = new Date(
        today.getFullYear(),
        today.getMonth() - 3,
        1
      );

      // Set the day to 1 to get the first day of three months ago
      threeMonthsAgo.setDate(1);

      const lastDayOfThreeMonthsAgo = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );

      const formattedStartDate = threeMonthsAgo.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      const formattedEndDate = lastDayOfThreeMonthsAgo.toLocaleDateString(
        "en-IN",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          timeZone: "Asia/Kolkata",
        }
      );

      setSearchValue((prevSearchDates) => ({
        ...prevSearchDates,
        eventStart: formattedStartDate
          .replaceAll("/", "-")
          .split("-")
          .reverse()
          .join("-"),
        eventEnd: formattedEndDate
          .replaceAll("/", "-")
          .split("-")
          .reverse()
          .join("-"),
      }));
    } else if (val == "all") {
      setSearchValue((prevSearchDates) => ({
        ...prevSearchDates,
        eventStart: "",
        eventEnd: "",
      }));
    }
  }

  const handleuploadExcel = async () => {
    setBackDropOpen(true);
    const res = await axios.post(
      `CbbfOptometristsReport?fromDate=${searchValue.eventStart}&toDate=${
        searchValue.eventEnd
      }&hospital_name=${filterValue.hospitalName}&camp_number=${filterValue.camp_num}&camp_place=${
        filterValue.camp_place
      }&limit=&page=${1}` + (filterValue.field_worker_id ? `&field_worker_id=${
            filterValue.field_worker_id
          }` : '')
    );

    const row = res?.data?.result?.list;

    // let newArrayOfObj = data.map(({ id: phone_number, ...rest }) => ({ phone_number, ...rest }));

    if (value.length > 1) {
      value.sort((x, y) => x.position - y.position);
    }

    var result = [];

    row?.map((x) => {
      var data = {};
      value?.map((i) => {
        data[i.header] = x[i.value];
      });
      result.push(data);
    });
    CSVFileDownload(result, "VolunteersOptomIdReport");
    setDownloadTab((o) => !o);
    setDateSearch("");
    setValue([]);
    setBackDropOpen(false);

    // let newArr = newArrayOfObj?.map((obj) => {
    //     const newObj = { ...obj };
    //     delete newObj["_id"]
    //     delete newObj["created_on"];
    //     delete newObj["modify_on"]
    //     return newObj;
    // })
    // let excelDownload = newArr.map(({
    //     village_name: VillageName, camp_place: CampPlace, camp_no: CampNumber, name: Name, phone_number: PhoneNumber, gender: Gender,
    //     complaint: Complaint, defect_vision_left: DefectVisionLeftEye, defect_vision_right: DefectVisonRight, already_wear_glass_yes: AlreadywearGlassYes, already_wear_glass_no: AlreadywearGlassNo, diagnosis_left: DiagnosisLeft, diagnosis_right: DiagnosisRight, near_vis_left_sph: NearVisionLeftEyeSPH,
    //     near_vis_left_bcva: NearVisonLeftBCVA, near_vis_left_cyl: NearVisonLeftCYL, near_vis_left_axis: NearVisionLeftAxis, near_vis_right_sph: NearVisonRightSPH, near_vis_right_bcva: NearVisonRightBCVA, near_vis_right_cyl: NearVisionRightCYL, near_vis_right_axis: NearVisionRightAxis,
    //     dis_vis_left_sph: DistanceVisonLeftSPh, dis_vis_left_bcva: DistanceVisonLeftBCVA, dis_vis_left_cyl: DIstanceVisonLeftCYL, dis_vis_left_axis: DistanceVisonLeftAxis, dis_vis_right_sph: DistanceVisonRightSph,

    //     dis_vis_right_bcva: DistanceVisonRightBCVA, dis_vis_right_cyl: DistanceVisonRightCYL, dis_vis_right_axis: DistanceVisonRightAxis, frame_size: FrameSize,
    //     surgery_fit: SurgeryFit, others: Others, advice_to: AdviceTo

    // }) => ({
    //     VillageName, CampPlace, CampNumber, Name, PhoneNumber, Gender,
    //     Complaint, DefectVisionLeftEye, DefectVisonRight, AlreadywearGlassYes, AlreadywearGlassNo, DiagnosisLeft, DiagnosisRight, NearVisionLeftEyeSPH,
    //     NearVisonLeftBCVA, NearVisonLeftCYL, NearVisionLeftAxis, NearVisonRightSPH, NearVisonRightBCVA, NearVisionRightCYL, NearVisionRightAxis,
    //     DistanceVisonLeftSPh, DistanceVisonLeftBCVA, DIstanceVisonLeftCYL, DistanceVisonLeftAxis, DistanceVisonRightSph,
    //     DistanceVisonRightBCVA, DistanceVisonRightCYL, DistanceVisonRightAxis, FrameSize, SurgeryFit, Others, AdviceTo
    // }));
    // ExcelDownload(excelDownload, "CbbfOptemIdReport");
  };
  const filteredObjectArray = (val) => {
    setFilterValue(val);
    setPaginationModel({ ...paginationModel, page: 0 });
  };

  return (
    <div className="main-report">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px 0",
        }}
      >
        <Typography variant="h5" color="secondary" className="text-left">
          {/* CBBF Optem Report{" "} */}
          Optom ID Report
        </Typography>
        <Button
          sx={{ textTransform: "capitalize", width: "10%", margin: "0 10px" }}
          // disabled={rows?.length == 0}
          size="small"
          variant="contained"
          startIcon={<FileDownloadIcon />}
          onClick={() => {
            head.forEach((data) => {
              data.isChecked = false;
            });
            setSearchValue({
              eventStart: "",
              eventEnd: "",
            });
            setDownloadTab((k) => !k);
          }}
        >
          Excel Download
        </Button>
      </div>
      <div>
        <OptemIdReportFilter filterObject={(val) => filteredObjectArray(val)} />
      </div>

      {downloadTab && (
        <div className="tabbackground">
          <div className="downloadtab">
            <div className="table">
              <Table>
                <TableHead>
                  <tr>
                    {/* <th><Checkbox
                      onChange={(e) => {
                        handleSelectAll(e);
                      }}
                    />
                      Select all</th> */}
                    <th> </th>
                    <th>Columns </th>
                  </tr>
                </TableHead>
              </Table>
              <div className="filter">
                <FormControl style={{ width: "90%" }} size="small">
                  <Select
                    labelId="select-label"
                    id="select"
                    variant="standard"
                    label="Select Dates"
                    value={dateSearch}
                    onChange={(e) => {
                      handleDates(e.target.value);
                    }}
                  >
                    {dates?.map((option) => (
                      <MenuItem key={option.id} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {dateSearch == "custom" && (
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "45%" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="from_date"
                          value={
                            searchValue.eventStart == ""
                              ? null
                              : searchValue.eventStart
                          }
                          inputFormat="DD/MM/YYYY"
                          onChange={(e) => {
                            const selectedDate = e.$d;
                            if (selectedDate) {
                              setSearchValue({
                                ...searchValue,
                                eventStart: selectedDate,
                              });
                            } else {
                              setSearchValue({
                                ...searchValue,
                                eventStart: null,
                              });
                            }
                          }}
                          slotProps={{
                            actionBar: {
                              actions: ["clear"],
                            },
                          }}
                          renderInput={(props) =>
                            renderInputs(props, "From date", "date")
                          }
                        />
                      </LocalizationProvider>
                    </div>
                    <div style={{ width: "45%" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="from_date"
                          value={
                            searchValue.eventEnd == ""
                              ? null
                              : searchValue.eventEnd
                          }
                          inputFormat="DD/MM/YYYY"
                          onChange={(e) => {
                            setSearchValue({ ...searchValue, eventEnd: e.$d });
                          }}
                          renderInput={(props) =>
                            renderInputs(props, "To date", "date")
                          }
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                )}
              </div>
              <Table>
                <TableBody>
                  <tr>
                    <td></td>
                    <td></td>
                  </tr>
                  {headerValue?.map((head, index) => {
                    if (head.headerName !== "S no") {
                      return (
                        <TableRow key={index}>
                          <TableCell sx={{ textAlign: "center", width: "25%" }}>
                            <Checkbox
                              checked={head.isChecked}
                              onChange={(e) => {
                                handleChange(
                                  e,
                                  head.field,
                                  index,
                                  head.headerName
                                );
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: "center" }}>
                            {alterScreenName(head?.headerName)}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
                </TableBody>
              </Table>
            </div>
            <div className="downloadoptions">
              <Button
                variant="contained"
                onClick={() => {
                  setDownloadTab((k) => !k);
                  setDateSearch("");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={dateSearch == "" || value.length == 0}
                onClick={() => handleuploadExcel()}
              >
                Download
              </Button>{" "}
              {/*onClick={handleuploadExcel}*/}
            </div>
          </div>
        </div>
      )}

      <div className="table">
        <DataGrid
          localeText={{
            noRowsLabel: tableInfo?.info,
          }}
          style={{ height: "75vh", width: "95vw" }}
          sx={{
            boxShadow: 2,
            overflowX: "auto",
            border: 2,
            textTransform: "capitalize",
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .super-app-theme--header": {
              backgroundColor: "LightBlue",
            },
          }}
          // autoHeight
          rows={rows}
          columns={columns}
          slots={{ toolbar: CustomToolBar }}
          disableDensitySelector
          ColumnFilter={<FieldWorkerFilter />}
          rowCount={length}
          page={paginationModel.page}
          //  disableColumnFilter
          components={{
            FilterPanel: <FieldWorkerFilter />,
          }}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                /* village_name: true,
                camp_place: true,
                camp_no: true,
                name: true,
                phone_number: true,
                gender: true,
                complaint: true,
                defect_vision_left: false,
                defect_vision_right: false,
                already_wear_glass_yes: true,
                already_wear_glass_no: false,
                diagnosis_left: false,
                diagnosis_right: false,
                near_vis_left_sph: false,
                near_vis_left_bcva: false,
                near_vis_left_cyl: false,
                near_vis_left_axis: false,
                near_vis_right_sph: false,
                visual_acuity_right: false,
                near_vis_right_bcva: false,
                near_vis_right_cyl: false,
                near_vis_right_axis: false,
                dis_vis_left_sph: false,
                dis_vis_left_bcva: false,
                dis_vis_left_cyl: false,
                dis_vis_left_axis: false,
                dis_vis_right_sph: false,
                dis_vis_right_bcva: false,
                dis_vis_right_cyl: false,
                dis_vis_right_axis: false,
                frame_size: false,
                surgery_fit: false,
                others: false,
                advice_to: false,
                surgery_status: false,
                glass_prescription_status: false,
                base_hospital_status: false,
                vision_center_status: false, */
              },
            },
          }}
        />
      </div>

      {/* backdrop */}
      <BackDrop open={backDropOpen} />
    </div>
  );
};

export default CbbfOptemReport;
